export class WorklistRequest{
    type:string;
    center:string;
    filter:string;

    constructor(type:string,center:string,filter:string){
        this.type = type;
        this.center = center;
        this.filter = filter;
    }
}